import * as angular from "angular";
import template from "./entity-aliases-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityAliasesTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
}

// eslint-disable-next-line no-redeclare
export class EntityAliasesTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewAliases = globs.entityTypes.byType(this.typeConfig.Code).aliases.byCode("*").read;
		this.tab = {
			name: "Aliases",
			code: "ALIASES",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewAliases)
				&& isSupportedOrNullish(this.typeConfig.Aliases)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-aliases-tab", [])
	.component("entityAliasesTab", {
		controller: EntityAliasesTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<"
		}
	})
	.name;
